export default __webpack_public_path__ + "static/media/19.b337281d.jpg";